import { AddHighlightTypes } from './utils.types';

const addHighlightBold700 = (string: AddHighlightTypes) => {
  const regexHighlightBold = string?.replace(
    /\[([\s\S]*?)\]/g,
    '<span style="font-weight: 700; text-wrap: pretty; display: inline-block;"}>$1</span>',
  );
  return regexHighlightBold;
};

export default addHighlightBold700;
